import React, { useMemo } from 'react'
import { Card } from '@themesberg/react-bootstrap'

const formatCount = (value) => {
  const amount = Number(value)
  if (!Number.isFinite(amount)) return '0'
  return new Intl.NumberFormat('vi-VN').format(amount)
}

const parseResultDate = (value) => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(String(value || ''))
  if (!match) return 0
  return new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1])).getTime()
}

const saleTypeLabel = (userType) => {
  const type = Number(userType)
  if (type === 1) return 'Bán quầy'
  if (type === 0) return 'Bán online'
  return 'Trả ế'
}

const CartTicketSummary = ({ total = 0, data = [] }) => {
  const groups = useMemo(() => {
    const byDate = new Map()

    ;(data || []).forEach((item) => {
      const date = item.resultDate || 'Không rõ ngày'
      if (!byDate.has(date)) {
        byDate.set(date, { date, total: 0, stations: [] })
      }

      const group = byDate.get(date)
      const sum = Number(item.sum) || 0
      group.total += sum
      group.stations.push({
        name: item.name || 'Không rõ đài',
        userType: Number(item.userType),
        sum,
      })
    })

    const list = Array.from(byDate.values())
    list.sort((a, b) => parseResultDate(b.date) - parseResultDate(a.date))
    list.forEach((group) => {
      group.stations.sort((a, b) => a.name.localeCompare(b.name, 'vi') || a.userType - b.userType)
    })
    return list
  }, [data])

  return (
    <Card border="light" className="shadow-sm mb-4" style={{ borderRadius: 12, overflow: 'hidden' }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 16,
        padding: '18px 20px',
        background: 'linear-gradient(135deg, #262B40 0%, #424AA0 100%)',
        color: '#fff',
      }}>
        <div>
          <div style={{ fontSize: 12, letterSpacing: 0.6, textTransform: 'uppercase', opacity: 0.75 }}>
            Tổng vé bán
          </div>
          <div style={{ fontSize: 32, fontWeight: 700, lineHeight: 1.15, marginTop: 4 }}>
            {formatCount(total)}
          </div>
        </div>
        <div style={{ fontSize: 13, opacity: 0.9 }}>
          {groups.length} ngày
        </div>
      </div>
      <Card.Body style={{ padding: 16 }}>
        {groups.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#6c757d', padding: '12px 0' }}>
            Chưa có vé
          </div>
        ) : groups.map((group) => (
          <div key={group.date} style={{ marginBottom: 14 }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              background: '#EBF4F6',
              borderRadius: 8,
              padding: '8px 12px',
              marginBottom: 8,
            }}>
              <span style={{ fontWeight: 700, color: '#262B40' }}>{group.date}</span>
              <span style={{ fontWeight: 700, color: '#424AA0' }}>{formatCount(group.total)} vé</span>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {group.stations.map((station) => (
                <div
                  key={`${group.date}-${station.name}-${station.userType}`}
                  style={{
                    flex: '1 1 160px',
                    maxWidth: 220,
                    border: '1px solid #e6eaf0',
                    borderRadius: 10,
                    padding: '10px 12px',
                    background: '#fff',
                  }}
                >
                  <div style={{ fontSize: 13, color: '#5a6275', marginBottom: 2 }}>{station.name}</div>
                  <div style={{ fontSize: 12, color: '#424AA0', marginBottom: 4 }}>{saleTypeLabel(station.userType)}</div>
                  <div style={{ fontSize: 18, fontWeight: 700, color: '#262B40' }}>{formatCount(station.sum)}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </Card.Body>
    </Card>
  )
}

export default CartTicketSummary
